/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImmunizationCatalogItem
 */
export interface ImmunizationCatalogItem {
    /**
     * Immutable identifier, server-assigned on create. Seeded items use the legacy immunizations.json name (e.g. Tdap) so schedule.json references and pre-catalog records keep resolving. Never changes on rename.
     * @type {string}
     * @memberof ImmunizationCatalogItem
     */
    id?: string;
    /**
     * Display name. Editable; identity lives in id.
     * @type {string}
     * @memberof ImmunizationCatalogItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationCatalogItem
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationCatalogItem
     */
    prescription?: string;
    /**
     * 
     * @type {string}
     * @memberof ImmunizationCatalogItem
     */
    din?: string;
    /**
     * False hides the item from new-record selection and tenant fee setup. Inactive items still resolve for schedule generation and historical records. Items are never hard-deleted.
     * @type {boolean}
     * @memberof ImmunizationCatalogItem
     */
    active?: boolean;
}

/**
 * Check if a given object implements the ImmunizationCatalogItem interface.
 */
export function instanceOfImmunizationCatalogItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function ImmunizationCatalogItemFromJSON(json: any): ImmunizationCatalogItem {
    return ImmunizationCatalogItemFromJSONTyped(json, false);
}

export function ImmunizationCatalogItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImmunizationCatalogItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'prescription': !exists(json, 'prescription') ? undefined : json['prescription'],
        'din': !exists(json, 'din') ? undefined : json['din'],
        'active': !exists(json, 'active') ? undefined : json['active'],
    };
}

export function ImmunizationCatalogItemToJSON(value?: ImmunizationCatalogItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'prescription': value.prescription,
        'din': value.din,
        'active': value.active,
    };
}

